<template>
  <div>
    <el-input
      :id="id"
      ref="mac"
      v-model="ele"
      size="small"
      maxlength="17"
      :disabled="disabled"
      :placeholder="placeholder"
      @keyup.native="change()"
      @mouseup.native="change()"
      @input="change()"
    />
  </div>
</template>
<script>
// import { logWithPrefix } from '@/plugins/logging'
// const log = logWithPrefix('[components/elements/macAddress.vue]')
export default {
  props: {
    id: {
      type: String,
      default: "mac",
    },
    config: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    allowColon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      ele: "",
    };
  },
  watch: {
    config: {
      handler() {
        this.ele = this.config;
        this.change();
      },
      immediate: true,
    },
  },
  methods: {
    change() {
      const val = this.ele.toUpperCase();
      const valLen = val.length;
      let newVal = "";
      let newLen = 0;

      // Auto add ':'

      for (let i = 0; i < valLen && i < 17; i++) {
        if (/[0-9A-F]/.test(val.charAt(i))) {
          newVal += val.charAt(i);
          newLen++;
          if (newLen >= 12) {
            break;
          }
          if (this.allowColon) {
            if (newLen > 0 && newLen % 2 === 0 && i !== valLen - 1) {
              newVal += ":";
            }
          }
        }
      }

      this.ele = newVal;
      this.$emit("update:config", this.ele);
    },
  },
};
</script>
